// Dynamic API URL that works in all environments
const getApiUrl = (): string => {
  // 1. If VITE_API_URL is explicitly set, use it (for local development or docker)
  if (import.meta.env.VITE_API_URL) {
    console.log('Using VITE_API_URL:', import.meta.env.VITE_API_URL);
    return import.meta.env.VITE_API_URL;
  }

  // 2. If running in browser, detect environment
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    console.log('Detected hostname:', hostname);

    // Local development (npm run dev)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('Using local development API URL');
      return 'http://localhost:8000';
    }

    // Azure or any other environment - use relative URLs for nginx proxy
    console.log('Using relative URLs for production/Azure');
    return '';
  }

  // Fallback for SSR or other scenarios
  console.log('Using fallback empty API URL');
  return '';
};

const apiUrl = getApiUrl();
console.log('Final API URL:', apiUrl);

export { apiUrl };
